import { createContext, useContext } from 'react'

export const OnboardingContext = createContext({
  count: 0,
  currentStepId: 1,
  isLoading: false,
  isStepValid: false,
  isGetStarted: false,
  isStepTwoDraftRestored: false,
  isStepOneDraftRestored: false,
  isExploreMyOptionsSelected: false,
  reasonForUsingBot: {},
  mainGoals: [],
  steps: []
})

export const useOnboardingContext = () => useContext(OnboardingContext)
